import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useChangeChallengeStatus = () => {
  return useMutation((data) => {
    return axiosPost("/api/cw/challengeStatusChange", data);
  });
};

export default useChangeChallengeStatus;
